import { AppointmentDetailsLocale } from '../interfaces';
import { ProviderOutput } from 'graphql/generated/hasura';
import { Link } from 'react-router-dom';
import React, { useMemo } from 'react';
import { PROVIDERS_PROVIDER_BIO } from 'utilities/routes';
import { useGetSignedUrlFromStorage } from 'hooks/useGetSignedUrlFromStorage';
import { Card } from '../../../app/my-appointments/components/Card';
import Avatar from '../../avatarComponent';
import { getAddress } from 'utilities/functions';

interface IProviderInfo {
  locale: AppointmentDetailsLocale;
  provider: ProviderOutput;
}

export function ProviderInfo({ locale, provider }: IProviderInfo) {
  const providerFullName = `${provider?.SENSITIVE_firstname || ''} ${
    provider?.SENSITIVE_lastname || ''
  }`;

  const signedProfileUrl = useGetSignedUrlFromStorage(
    provider.SENSITIVE_profile_picture_id || '',
    provider?.id,
  );

  const experience = useMemo(() => {
    const certification = provider?.SENSITIVE_credentials?.certifications?.[0];
    const experience = provider?.SENSITIVE_credentials?.yearsOfPractice || 0;
    return [
      certification,
      `${experience} ${
        experience < 2 ? 'Year of experience' : 'Years of experience'
      }`,
    ];
  }, [provider]);

  return (
    <Card
      title={locale.providerInfo || 'Provider info'}
      titleClassName="flex text-h4 text-btn-black font-semibold"
      alwaysExpanded
      showSeparator
      rightComponentWrap={false}
      backgroundColor="p-30 bg-white"
      rightComponent={
        <Link
          className="text-clc-blue text-sm uppercase font-bold underline"
          target="_blank"
          rel="opener"
          to={{
            pathname: PROVIDERS_PROVIDER_BIO,
            search: `?providerId=${provider.id}`,
          }}
          state={{ providerId: provider.id }}
          data-testid="go-to-provider-bio-info"
        >
          {locale.profile}
        </Link>
      }
      testId={'provider-info'}
    >
      <div className="flex w-full flex-col gap-2.5">
        <Avatar
          size="sm"
          key={signedProfileUrl}
          imageUrl={signedProfileUrl}
          customClasses="h-16 w-16 rounded-full mr-2"
        />
        <div className="font-semibold text-xl">{providerFullName}</div>

        <p className="max-desktop:hidden text-med-gray-3 text-h6 font-normal text-left">
          {experience.join(' • ')}
        </p>
        <p className="desktop:hidden flex flex-col gap-2.5 text-med-gray-3 text-h6 font-normal text-left">
          {experience.map((line) => (
            <p>{line}</p>
          ))}
        </p>
        <p className="text-med-gray-3 text-h6 font-normal text-left">
          {getAddress(provider.SENSITIVE_office_information)}
        </p>
      </div>
    </Card>
  );
}
